import React, { FC } from 'react';
import { ISelect } from '@common/types/element';

import { Text, View } from 'react-native';
import CustomPicker from './Picker';
import createStyles, { errorStyles } from './style';
import connectorInput from '../ConnectorInput';

const Dropdown: FC<ISelect> = (attributes) => {
  const { inputError } = attributes;
  const styles = createStyles(attributes);
  return (
    <View
      style={[
        styles.container,
        { width: attributes.style?.width || attributes.width },
      ]}
      nativeID={`select-${attributes.id}`}
    >
      <CustomPicker {...attributes} />
      {inputError ? (
        <Text style={[errorStyles.errorMessage]}>{inputError}</Text>
      ) : null}
    </View>
  );
};

export default connectorInput(Dropdown);
